import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Create axios instance with default config
const apiClient = axios.create({
  baseURL: API,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
  maxRedirects: 5, // Follow redirects
});

// Add request interceptor for logging
apiClient.interceptors.request.use(
  (config) => {
    console.log(`API Request: ${config.method?.toUpperCase()} ${config.url}`);
    return config;
  },
  (error) => {
    console.error('API Request Error:', error);
    return Promise.reject(error);
  }
);

// Add response interceptor for error handling
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('API Response Error:', error.response?.data || error.message);
    return Promise.reject(error);
  }
);

// Truck API endpoints
export const trucksAPI = {
  // Get all trucks with optional filtering
  getTrucks: async (filters = {}) => {
    const params = new URLSearchParams();
    
    if (filters.make) params.append('make', filters.make);
    if (filters.year) params.append('year', filters.year.toString());
    if (filters.featured !== undefined) params.append('featured', filters.featured.toString());
    if (filters.available_for_hire !== undefined) params.append('available_for_hire', filters.available_for_hire.toString());
    if (filters.search) params.append('search', filters.search);
    if (filters.skip) params.append('skip', filters.skip.toString());
    if (filters.limit) params.append('limit', filters.limit.toString());
    
    const response = await apiClient.get(`/trucks?${params.toString()}`);
    return response.data;
  },

  // Get single truck by ID
  getTruck: async (truckId) => {
    const response = await apiClient.get(`/trucks/${truckId}`);
    return response.data;
  },

  // Create new truck
  createTruck: async (truckData) => {
    const response = await apiClient.post('/trucks', truckData);
    return response.data;
  },

  // Update existing truck
  updateTruck: async (truckId, truckData) => {
    const response = await apiClient.put(`/trucks/${truckId}`, truckData);
    return response.data;
  },

  // Delete truck
  deleteTruck: async (truckId) => {
    const response = await apiClient.delete(`/trucks/${truckId}`);
    return response.data;
  },
};

// Site content API endpoints
export const contentAPI = {
  // Get all site content
  getAllContent: async () => {
    const response = await apiClient.get('/content');
    return response.data;
  },

  // Get content for specific section
  getContentSection: async (section) => {
    const response = await apiClient.get(`/content/${section}`);
    return response.data;
  },

  // Update content section
  updateContentSection: async (section, content) => {
    const response = await apiClient.put(`/content/${section}`, { content });
    return response.data;
  },
};

// Health check
export const healthAPI = {
  check: async () => {
    const response = await apiClient.get('/health');
    return response.data;
  },
};

// Error handler for components
export const handleAPIError = (error, defaultMessage = 'An error occurred') => {
  if (error.response?.data?.detail) {
    return error.response.data.detail;
  }
  if (error.message) {
    return error.message;
  }
  return defaultMessage;
};

export default apiClient;